<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn fab dark small color="#E65100" v-on="{ ...on, ...tooltipOn }">
            <v-icon dark>send_time_extension</v-icon>
          </v-btn>
        </template>
        <span>Reported Probable Generate</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title style="background-color: #3f51b5; color: #fff">
        <span class="headline"
          >Reported Probable Generate (Registration wise)</span
        >
        <v-spacer></v-spacer>
        <v-btn color="red" fab small dark @click="clearData()"
          ><v-icon>close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          wrap
          v-if="!allRepProbableGen"
          style="margin-bottom:-28px;"
        >
          <v-flex xs12>
            <v-text-field
              class="custom-multiline-text-field"
              v-model="formattedNumber"
              label="Enter Reported Registration Numbers"
              @input="formatInput"
              :error-messages="errorMessage"
              textarea
            ></v-text-field>
          </v-flex>
        </v-layout>
        <small v-if="!allRepProbableGen" style="color: red; font-size: 13px;"
          >Enter Registration Number With
          <strong>Comma (,)</strong> separated</small
        >
        <div
          v-if="formattedNumber == '' && !allRepProbableGen"
          style="margin-left: 46%; margin-top:10px;"
        >
          <h4><b>OR</b></h4>
        </div>
        <span v-if="formattedNumber == ''">
          <v-checkbox
            v-model="allRepProbableGen"
            label="Generate all reported probable"
            color="success"
          ></v-checkbox>
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="showBot == 1 && formattedNumber != ''"
          color="indigo"
          style="color:#fff;"
          @click="
            $event.preventDefault();
            $event.stopPropagation();
            generateRepProb();
          "
          >submit</v-btn
        >

        <v-btn
          v-if="allRepProbableGen && formattedNumber == ''"
          color="indigo"
          style="color:#fff;"
          @click="
            $event.preventDefault();
            $event.stopPropagation();
            generateRepProb();
          "
          >Generate</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      allRepProbableGen: false,
      dialog: false,
      number: "",
      formattedNumber: "",
      errorMessage: "",
      showBot: 1,
    };
  },
  created: {},
  computed: {},
  methods: {
    formatInput() {
      if (/[A-Za-z]/.test(this.formattedNumber)) {
        this.errorMessage = "Only numbers are accepted";
        this.showBot = 0;
        return;
      } else {
        this.errorMessage = "";
        this.showBot = 1;
      }
      const plainNumber = this.formattedNumber.replace(/,/g, "");
      const formattedValue = plainNumber.replace(/(.{11})(?!$)/g, "$1,");
      this.formattedNumber = formattedValue;
      this.number = plainNumber;
    },

    generateRepProb() {
      let param = {};
      param.criteria_id = this.item.id;
      param.exam_code = this.item.exam_code;
      param.exam_year = this.item.exam_year;
      param.exam_initiate_id = this.item.exam_initiate_id;
      if (this.allRepProbableGen && this.formattedNumber == "") {
        param.reg_no = "";
      } else {
        param.reg_no = this.formattedNumber;
      }
      console.log("Tanvir! This is reg data", param);
      this.$store.dispatch("startGeReportedProbable", param);
      this.dialog = true;
    },

    clearData() {
      this.formattedNumber = "";
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.custom-multiline-text-field .v-input__control {
  height: 160px; /* Adjust height as needed */
}

.custom-multiline-text-field .v-input__slot {
  white-space: pre-wrap; /* Maintains line breaks in the text */
}
</style>
